import { get, post, put } from '../axios/axiosGateway';

export const getDiscoveredDevices = gateway => {
  return get(`/discovered-devices/${gateway}`);
};

export const pairGateway = gateway => {
  return post(`/gateways/${gateway}/pair`);
};

export const setDeviceProperty = (gateway, id, payload) => {
  return put(`/actuators/${gateway}/${id}/set`, payload);
};

export const addBatchDevices = (gateway, payload) => {
  return post(`/breeze/${gateway}/materialize`, payload);
};
